module.exports = __webpack_public_path__ + "img/bottle.0cde780e.webp";